var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaturcenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.832,5.762,9.579,2.282a.276.276,0,0,0-.349,0L6.439,4.565,5.6,3.881a.276.276,0,0,0-.349,0L1.747,6.75a.161.161,0,0,0,.1.286h.406V11.61a.178.178,0,0,0,.178.177H13.1a.183.183,0,0,0,.163-.2V6.051l0,0h.472A.16.16,0,0,0,13.832,5.762ZM9.343,9.526a.8.8,0,0,1-1-.164l-.39.225v1.146a.089.089,0,0,1-.089.089H7.725a.089.089,0,0,1-.089-.089V9.587l-.39-.225a.8.8,0,0,1-1,.164,3.942,3.942,0,0,1-1-1.5,3.937,3.937,0,0,1,1.8.117.8.8,0,0,1,.359.948l.231.134v-1.2a.8.8,0,0,1-.642-.784,3.944,3.944,0,0,1,.8-1.62,3.934,3.934,0,0,1,.8,1.62.8.8,0,0,1-.642.784v1.2l.231-.134a.8.8,0,0,1,.359-.948,3.937,3.937,0,0,1,1.8-.117A3.942,3.942,0,0,1,9.343,9.526Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturcenter);
export default __webpack_public_path__ + "static/media/NATURCENTER.0202db44ca84076bc1ab55847310ef6a.svg";
export { ForwardRef as ReactComponent };